/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, ViewChild, Input } from '@angular/core';
import { GenericTableData } from '../../sharedServices/generic-table-data.service';
import { Action } from '../../models/enums/Action.enum';
import { DialogBoxComponent } from '../../shared/dialog-box/dialog-box.component';
import { Subject } from 'rxjs';

import { UserHandlerService } from '../../sharedServices/user-handler.service';
import { SearchService } from 'api/services';
import { FittingDto, ActionTypeEnumDto } from 'api/models';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';


@Component({
  selector: 'app-search-fitting',
  templateUrl: './search-fitting.component.html',
  styleUrls: ['./search-fitting.component.css']
})
export class SearchFittingComponent {
  @ViewChild(MatMenuTrigger) contextMenu: MatMenuTrigger;
  contextMenuPosition = { x: '0px', y: '0px' };
  resetFittingsTableSubject: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly searchService: SearchService,
    public fittingDataService: GenericTableData,
    private readonly userHandlerService: UserHandlerService,
    private readonly dialog: MatDialog,

  ) { }
  


  onContextMenuClick(event) {
    this.contextMenuPosition.x = event.mouseEvent.clientX + 'px';
    this.contextMenuPosition.y = event.mouseEvent.clientY + 'px';
    this.contextMenu.menuData = { element: event.element };
    this.contextMenu.openMenu();
  }
  onAddAction(elements: FittingDto[]) {
    elements.forEach(item => {
      item.isEnable = false;
      item.action = Action.ToAdd;
      item.statusID = ActionTypeEnumDto.Add;
    });

    this.SendFittingToEdit(elements);
  }
  onUpdateAction(elements: FittingDto[]) {
    elements.forEach(item => {
      item.isEnable = false;
      item.action = Action.ToUpdate;
      item.statusID = ActionTypeEnumDto.Update;
    });
    this.SendFittingToEdit(elements);
  }
  onDeleteAction(elements: FittingDto[]) {
    elements.forEach(item => {
      item.isEnable = false;
      item.action = Action.ToDelete;
      item.statusID = ActionTypeEnumDto.Delete;
    });

    this.SendFittingToEdit(elements);
  }

  onChangeFittingStateActionToContinue(elements: FittingDto[]) {
    elements.forEach(item => {
      item.isEnable = false;
      item.action = Action.ToChangeState;
      item.statusID = ActionTypeEnumDto.ChangeToContinue;
    });

    this.SendFittingToEdit(elements);
  }

  onChangeFittingStateActionToDiscontinue(elements: FittingDto[]) {
    elements.forEach(item => {
      item.isEnable = false;
      item.action = Action.ToChangeState;
      item.statusID = ActionTypeEnumDto.ChangeToDiscontinue;
    });

    this.SendFittingToEdit(elements);
  }

  resetFittingsTable() {
    this.resetFittingsTableSubject.next(true);
  }

  IsContinued(elements: FittingDto[]) {
    return elements.every(item => item.isContinued === 'True');

  }

  SendFittingToEdit(elements: FittingDto[]) {
    const currentUser = this.userHandlerService.getCurrentUser();
    elements.forEach(item => {
      item.actionBy = currentUser.fullName;
      item.changeby = currentUser.userID;
    });

    this.searchService.addAssignedActionForSelectedFitting({ body: elements })
      .subscribe(elementsAlreadyExists => {
          /* istanbul ignore if*/
        if (elementsAlreadyExists.length > 0) {
          this.onAssignExistingFittingOpenDialog(elementsAlreadyExists);
        }
      });
  }

  onAssignExistingFittingOpenDialog(elements: FittingDto[]) {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      data: {
        title: 'Fitting assigned by another user',
        message:
          'This fitting has been already assigned to another user. It may be possible that other fittings has been assigned.'
      }
    });
    elements.forEach(element => {
      this.handleFittingAssignedDialogButtons(dialogRef, element);
    });
  }

  handleFittingAssignedDialogButtons(
    dialogRef: MatDialogRef<DialogBoxComponent, any>, element: FittingDto
  ) {
    const subscribeOk = dialogRef.componentInstance.okClickEvent.subscribe(
      () => {
        element.action = Action.AddedByAnotherUser;
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      subscribeOk.unsubscribe();
    });
  }
}
